import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Path } from './@core/enums/path.enum';
import { AuthGuard, NoAuthGuard, AdminGuard} from './@core/guards';
import { NotFoundPage } from './public/pages/not-found/not-found.page';
import { SignUpPage } from './+auth/pages/sign-up/sign-up.page';
import {GabadooPage} from '@app/dashboard/pages/gabadoo/gabadoo.page';
import {PartnerVerifiedGuard} from '@core/guards/partner-verified.guard';

const routes: Routes = [
  // ===== Uncomment if Path.Home is different from empty =====
  // { path: '', redirectTo: Path.Home, pathMatch: 'full' },

  // Public
  {
    path: '',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  },

  // Auth
  {
    path: Path.Auth,
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./+auth/auth.module').then((m) => m.AuthModule),
  },

  // Admin dashboard
  {
    path: Path.Admin,
    canActivate: [AdminGuard],
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },

  // Partner Routes
  {
    path: Path.Partner,
    canActivate: [PartnerVerifiedGuard],
    loadChildren: () => import('./partner/partner.module').then((m) => m.PartnerModule),
  },

  // Therpist sign up
  {
    path: Path.TherapistSignUp,
    canActivate: [NoAuthGuard],
    component: SignUpPage,
  },

  // Therapist Routes
  {
    path: Path.Therapist,
    redirectTo: `${Path.Therapist}/${Path.TherapistDashboard}`,
    pathMatch: 'full',
  },

  // Therapist after sign in Routes
  {
    path: Path.Therapist,
    canActivate: [AuthGuard],
    loadChildren: () => import('./therapist/therapist.module').then((m) => m.TherapistModule),
  },

  // App
  {
    path: Path.App,
    redirectTo: `${Path.App}/${Path.ParentHome}`,
    pathMatch: 'full',
  },
  {
    path: Path.App,
    canActivate: [AuthGuard],
    children: [
      {
        path: Path.ParentHome,
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
    ],
  },
  { path: Path.Gabadoo, component: GabadooPage},

  // Not found page (must go at the bottom)
  {
    path: '**',
    component: NotFoundPage,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
